export default {
  customize: {
    orders: 'Orders',
    customers: 'Customers',
    setting: 'Setting',
    shopName: 'Shop Name',
    username: 'Username',
    logout: 'Log Out',

    // order
    orderList: 'Orders List',
    allOrders: 'All orders',
    unpaid: 'Unpaid',
    partialyPaid: 'Partialy paid',
    paid: 'Paid',
    picking: 'Picking',
    shipped: 'Shipped',
    completed: 'Completed',
    requestRefund: 'Request refund',
    refundFinished: 'Refund finished',
    closed: 'Closed',
    未付款: 'Unpaid',
    部分付款: 'Partialy paid',
    '已付款（待发货）': 'Paid',
    配货中: 'Picking',
    '已发货（待完成）': 'Shipped',
    '未付款已发货（待完成）': 'Unpaid and shipped',
    交易完成: 'Completed',
    申请退款: 'Request refund',
    退款完成: 'Refund finished',
    用户取消订单后关闭: 'Closed (Customer closed)',
    退款完成后关闭: 'Closed (Refund finished)',
    管理员关闭订单并退款: 'Closed (Admin closed and refund)',
    管理员关闭订单: 'Closed (Admin closed)',
    支付超时关闭订单: 'Closed (Time out)',
    已关闭: 'Closed',
    pickUp: 'Pick up',
    wechatName: 'WeChat Name:',
    phone: 'Mobile Number:',
    goodsValue: 'Value of Goods:',
    shippingFee: 'Shipping Fee:',
    totalFee: 'Total Fee:',
    unbound: 'Unbound',

    // order details
    undefined: '',
    orderDetails: 'Order Details',
    addExpressNo: 'Add Express No.',
    uploadImg: 'Upload Images',
    checkOrder: 'Order Check',
    orderOperation: 'Order Operation',
    statusOperation: 'Status Operation',
    toCustomer: 'To Customer',
    goodsList: 'Goods List',
    expressInfo: 'Express Info',
    orderAttachment: 'Attachment',
    operationLog: 'Operation Log',
    updateOrder: 'Update Order',
    orderStatus: 'Order Status',
    orderValue: 'Value of Order',
    others: 'Others',
    new: 'New',
    confirmUpdateOrder: 'Confirm to uodate the order?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    updateSuccess: 'Update order successfully',
    updateFail: 'Update order failed',
    loading: 'Loading...',
    createAt: 'Create At:',
    none: 'None',
    goodsValueBeforeDiscount: 'Value of Goods Before Discount',
    expressFeeBeforeDiscount: 'Express Fee Before Discount',
    goodsFeeAfter: 'Value of Goods After Discount',
    expressFeeAfter: 'Express Fee After Discount',
    finalFee: 'Final Fee',
    consignee: 'Consignee:',
    idCardNo: 'ID Card No.:',
    address: 'Address:',
    consigner: 'Consigner:',
    paidAt: 'Paid At',
    shippingAt: 'Shipping At',
    finishedAt: 'Finished At',
    expressCompany: 'Express Company',
    expressNoPlaceHolder: 'Use "," to separate if input serveral express No.',
    scanExpressCode: 'Scan Express Code',
    clickUpload: 'Upload Images',
    confirmDeleteImage: 'Confirm Delete Image',
    deletingImg: 'Deleting...',
    deleteImgSuccess: 'Image Deleted',
    deleteImgFail: 'Delete image failed',
    uploadImgFail: 'Upload image failed, please try again',
    saveImgSuccess: 'Image saved',
    saveImgFail: 'Save image failed',
    uploadingImg: 'Uploading...',
    uploadQiniuFail: 'Upload image to Qiniu failed',
    getTokenFail: 'Get Qiniu token failed',
    cancelRefund: 'Cancel refund',
    refundToCredit: 'Refund to credit',
    operationNotes: 'Operation notes',
    pleaseInput: 'Please input the content',
    leaveMessage: 'Leave a message to the customer',
    barCode: 'Bar code: ',
    bestBefore: 'Best before: ',
    noExpressInfo: 'No express info',
    operator: 'Operator:',
    operationType: 'Type:',
    operationTime: 'Time:',
    scanBarCode: 'Scan Bar Code',
    submit: 'Submit',
    finishCheck: 'The goods has been checked!',
    noMatchGoods: 'Did not match the goods!',
    checkSuccess: 'Check the order successfully!',
    checkFail: 'Check the order failed!',
    customerMessage: 'Customer Message',
    originalGoodsFee: 'Original goods fee',
    originalShippingFee: 'Original shipping fee',
    discountedGoodsFee: 'Discounted goods fee',
    discountedShippingFee: 'Discounted shipping fee',
    orderShopPrice: 'Order price',
    orderFinalPrice: 'Final total price',
    agentProfit: 'Agent profit',
    orderActivity: 'Promotion of Order',
    orderCoupon: 'Coupon of Order',
    promotionActivity: '（Promotion）',
    couponActivity: '（Coupon）',
    writeOffButton: 'Write Off',
    writeOffTitle: 'Goods have been picked up',
    writeOffSuccessfully: 'Write off successfully',
    writeOffFailed: 'Write off failed',
    refundType: 'Refund Type',
    refundToOPM: 'Refund to original payment method',
    refundToOffline: 'Refund offline',
    MyPayAccountBalanceNotEnough: 'MyPAY Account Balance not enough',
    poliPayRefundOperation: 'This order used POLi payment，please transfer the money to customer: ',

    // customer
    customerList: 'Customers List',
    level: 'Level',
    points: 'Points',
    expense: 'Expense',
    credit: 'Credit',
    registrationDate: 'Date of registration',
    customerDetails: 'Customer Details',
    customerRemark: 'Customer Remark',
    editLevel: 'Edit Level',
    edit: 'Edit',
    editCustomerRemark: 'Edit Customer Remark',
    updateRemarkSuccess: 'Update remark successfully',
    updateRemarkFail: 'Update remark failed',
    updateLevelSuccess: 'Update level successfully',
    updateLevelFail: 'Update level failed',
    accountCredit: 'Account Credit',
    nowCredit: 'Credit',
    editCredit: 'Edit credit',
    inputCredit: 'Input the value',
    creditAmount: 'Amount:',
    operationDetails: 'Details:',
    线上充值余额: 'Recharge credit online',
    商家操作增加余额: 'Admin operation (Increase credit)',
    退款余额: 'Refund to credit',
    购买商品使用余额: 'Paid by credit',
    商家操作减少余额: 'Admin operation (Reduce credit)',
    其他操作: 'Other operation',
    updateCreditSuccess: 'Update credit successfully',
    updateCreditFail: 'Update credit failed',
    comment: 'comment',

    // search
    orderSearch: 'Order Search',
    goBack: 'Go Back',
    search: 'Search',
    searchPlaceHolder: 'Order No., username, express No., consignee',
    customerSearch: 'Customer Search',
    customerPlaceHolder: 'Mobile No., WeChat name',

    orderWriteOff: 'Order Write-off',
    writeOffCode: 'Code'
  }
}
